export const DateFormat = {
  IsoFormat: 'YYYY-MM-DDTHH:mm:SS',
  UK: 'DD/MM/YYYY',
  US: 'MM/DD/YYYY'
};
